import { createContext } from 'react'
import { FuegoContextProps } from './types'

// @ts-ignore
export default createContext<FuegoContextProps>()
